import { Button, message, Modal, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import PersonsList from "../../Common/components/PersonsList";
import { PlusCircleFilled, UserAddOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { contractStoreHandle } from "../../ContractStore/state/actions";
import { formatClientAddress, formatPhoneNumber, generateFullNameFromObj } from "../../Common/utils/universalFuntions";
import { ClientList } from "./ClientList";

function EditAgentOnList({ modalState, setModalState, rootDocData, contractAuthKey, currentUrlId }) {
  const dispatch = useDispatch();
  const { agentType, uuidKey, editModalTitle, labelType, editAgentOnListModal } = modalState || {};
  const [showClientListModal, setShowClientListModal] = useState(false);
  const [showAddBrokerOptions, setShowAddBrokerOptions] = useState(false);
  const [agentData, setAgentData] = useState([]);
  const handleCloseEditAgentOnList = () => {
    setModalState({
      ...modalState,
      editAgentOnListModal: false,
    });
  };

  useEffect(() => {
    let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
    if (localData?.BuyerAgents?.length > 0) {
      setAgentData(localData?.BuyerAgents);
    }
  }, [modalState]);

  const handleEdit = (agent) => {
    setModalState({
      ...modalState,
      editAgentsModal: true,
      individualDetailsEdit: agent,
      personId: agent?._id || agent?.personId,
      agentType,
      labelType,
      editModalTitle,
      uuidKey: agent?.key || uuidKey || null,
    });
  };

  const handleAddBroker = () => {
    setShowAddBrokerOptions(false);
    setModalState({
      ...modalState,
      editAgentsModal: true,
    });
  };

  const handleDataChange = (updatedAgents = {}) => {
    try {
      let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
      localData = { ...localData, ...updatedAgents };
      localStorage.setItem(currentUrlId, JSON.stringify(localData));
      setAgentData(updatedAgents?.BuyerAgents || []);
      dispatch(contractStoreHandle.autoSaveContract({ currentUrlId, contractAuthKey, valueObj: { BuyerAgents: updatedAgents?.BuyerAgents || [] } }));
    } catch (error) {
      message.error("Failed to update agent data. Please try again.");
    }
  };

  const handleDeleteAgent = (agent) => {
    if (!agent || !agent.personId) return message.error("Invalid agent data!");
    Modal.confirm({
      title: `Are you sure you want to remove ${agent.fullName || "this Agent"} from the list?`,
      okText: "Yes",
      cancelText: "No",
      icon: <ExclamationCircleOutlined />,
      onOk() {
        try {
          let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
          let newData = localData.BuyerAgents?.filter((el) => el.personId !== agent.personId) || [];
          handleDataChange({ BuyerAgents: newData });
          message.success(`${agent.fullName || "Agent"} removed successfully.`);
        } catch (error) {
          console.error("Error deleting agent:", error);
          message.error("Failed to delete agent. Please try again.");
        }
      },
    });
  };
  const handleCancelShowAddBrokerOptions = () => {
    setShowAddBrokerOptions(false);
  };
  const handleCancel = () => {
    setShowClientListModal(false);
  };

  const handleClientSelected = (selectedClient) => {
    if (!selectedClient || !selectedClient._id) return;

    let localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
    const agentsArray = localData?.BuyerAgents || [];

    if (agentsArray.length >= 5) {
      message.error(`Maximum number of agents already added.`);
      return;
    }

    const newAgent = {
      _id: selectedClient._id,
      personId: selectedClient._id,
      fullName: generateFullNameFromObj(selectedClient),
      email: selectedClient.email,
      isContact: true,
      faxNumber: formatPhoneNumber(selectedClient?.faxNumber),
      address: formatClientAddress(selectedClient?.addressObj),
      phoneNumber: formatPhoneNumber(selectedClient?.mobilePhoneNumber?.phoneNumber),
    };

    if (agentsArray.some((a) => String(a._id) === String(newAgent._id))) {
      message.error(`${newAgent.fullName || "Agent"} already exists in the list.`);
      return;
    }

    const updatedAgents = [...agentsArray, newAgent];
    handleDataChange({ BuyerAgents: updatedAgents });
    message.success(`${newAgent.fullName || "Agent"} added to the list.`);
  };

  return (
    <>
      {/* Client List Modal */}
      {showClientListModal && (
        <Modal width={600} style={{ height: "600px" }} visible={showClientListModal} title={<div className="commonModalTitle">{""}</div>} onCancel={handleCancel} footer={null}>
          <ClientList onAdd={handleClientSelected} accessTokan={contractAuthKey} source={"Documents"} labelType={labelType} />
        </Modal>
      )}

      {/* Add Broker Options Modal */}
      <Modal visible={showAddBrokerOptions} onCancel={handleCancelShowAddBrokerOptions} footer={[]} zIndex={1050}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            width: "60%",
            margin: "auto",
          }}
        >
          <p
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              fontSize: "18px",
              color: "#2976be",
              cursor: "pointer",
            }}
            onClick={handleAddBroker}
          >
            <UserAddOutlined /> Add Via Email Search
          </p>
          <p
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              fontSize: "18px",
              color: "#2976be",
              cursor: "pointer",
            }}
            onClick={() => {
              setShowAddBrokerOptions(false);
              setShowClientListModal(true);
            }}
          >
            <UserAddOutlined /> Add From Contacts
          </p>
        </div>
      </Modal>
      {rootDocData?.propertyData?.transactionType === "BUILDER" && (
        <Modal
          visible={editAgentOnListModal}
          footer={null}
          onCancel={handleCloseEditAgentOnList}
          bodyStyle={{ paddingTop: 5 }}
          title={
            <div className="commonModalTitle" style={{ fontSize: 20 }}>
              Broker(s) List
              <span>
                <Tooltip title="Add Broker" trigger={["hover", "click"]}>
                  <PlusCircleFilled style={{ color: "#275291", fontSize: "20px", marginLeft: 10 }} onClick={() => setShowAddBrokerOptions(true)} />
                </Tooltip>
              </span>
            </div>
          }
        >
          <PersonsList dataSource={agentData} agentData={agentData} showEditIcon={true} showDeleteIcon={true} handleEdit={handleEdit} onDelete={handleDeleteAgent} />
          <div style={{ textAlign: "center", marginTop: 10 }}>
            <Button type="primary" onClick={handleCloseEditAgentOnList}>
              Done
            </Button>
          </div>
        </Modal>
      )}
    </>
  );
}

export default EditAgentOnList;
